var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "btn-group" }, [
    _vm.canReview
      ? _c(
          "button",
          {
            staticClass: "btn btn-success btn-sm",
            attrs: { title: "Approve" },
            on: { click: _vm.confirmApproving },
          },
          [_c("i", { staticClass: "fas fa-check fa-fw" })]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.canReview
      ? _c(
          "button",
          {
            staticClass: "btn btn-warning btn-sm",
            attrs: { title: "Reject" },
            on: { click: _vm.confirmRejecting },
          },
          [_c("i", { staticClass: "fas fa-times fa-fw" })]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.canEdit
      ? _c(
          "button",
          { staticClass: "btn btn-secondary btn-sm", on: { click: _vm.edit } },
          [_c("i", { staticClass: "fas fa-edit fa-fw" })]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.canDelete
      ? _c(
          "button",
          {
            staticClass: "btn btn-danger btn-sm",
            on: { click: _vm.confirmDeleting },
          },
          [_c("i", { staticClass: "fas fa-trash-alt fa-fw" })]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }